import { t } from 'i18next';
import { NoData } from '../../../../common/components/NoData';

export const PriorityFixes = () => {
  return <NoData title={t('blankState.priorityFixes.title')} />;
};
